/**
 * Shared formatting helpers used across multiple document templates.
 *
 * Date/time formatting delegates to `@snootsvet/shared`, whose formatters take
 * a required `DateFormat` — there is no default region. Documents are generated
 * output with no viewer, so callers resolve one with
 * `resolveDateFormat(clinicId, owner.region)` off their own payload rather than
 * the viewer's region.
 */
import {
  formatAge,
  formatCalendarDate,
  formatInstantDate,
  formatSex,
  resolveDateFormat,
} from '@snootsvet/shared'

export { formatAge, formatCalendarDate, formatInstantDate, formatSex, resolveDateFormat }

/** Format "HH:mm" as 12-hour time, e.g. "08:30" → "8:30 AM". */
export function formatArrivalTime(time: string): string {
  const [h, m] = time.split(':').map(Number)
  const period = h >= 12 ? 'PM' : 'AM'
  const hour12 = h % 12 || 12
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`
}
